export class InvalidAPIResponse extends Error {
  constructor (message, axiosError) {
    super(message)
    this.axiosError = axiosError
  }
}
